import React, { useEffect, useState } from 'react';
import Modal from '@common/modal';
import Switch from '@common/switch';
import Icon from '@common/assets';
import { useMarketingInfo, useUpdateMarketingInfoEmailSns } from '@repository/users/useUsers';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './marketingPolicyAgreeModal.module.scss';
const cx = classnames.bind(styles);

interface MarketingPolicyAgreeModalProps {
  visible: boolean;
  onClose: () => void;
  onOpenMarketingPolicyComplete: () => void;
}

const MarketingPolicyAgreeModal = ({
  visible,
  onClose,
  onOpenMarketingPolicyComplete,
}: MarketingPolicyAgreeModalProps) => {
  const [emailYn, setEmailYn] = useState(false);
  const [smsYn, setSmsYn] = useState(false);

  const { data: marketingInfoData } = useMarketingInfo(visible);
  const { mutate: updateMarketingInfoEmailSnsMutate } = useUpdateMarketingInfoEmailSns({
    onSuccess: () => onOpenMarketingPolicyComplete(),
  });

  const handleChangeEmailYn = () => {
    setEmailYn(!emailYn);
  };

  const handleChangeSmsYn = () => {
    setSmsYn(!smsYn);
  };

  const handleAgree = () => {
    updateMarketingInfoEmailSnsMutate();
  };

  useEffect(() => {
    if (marketingInfoData) {
      setEmailYn(marketingInfoData.emailYn);
      setSmsYn(marketingInfoData.smsYn);
    }
  }, [marketingInfoData]);

  if (!marketingInfoData) return null;

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>마케팅 수신 동의가 필요해요!</strong>
        <p className={cx('subTitle')}>
          리워드 지급을 위해
          <br />
          SMS, 이메일 알림 설정이 필요해요.
        </p>
        <div className={cx('agreeArea')}>
          <span className={cx('agreeInner')}>
            <span className={cx('infoTitle')}>SMS 알림 설정</span>
            <Switch onChange={handleChangeSmsYn} checked={smsYn} />
          </span>
          <div className={cx('agreeInner')}>
            <span className={cx('infoTitle')}>이메일 알림 설정</span>
            <Switch onChange={handleChangeEmailYn} checked={emailYn} />
          </div>
          <a href={RouteUrl.MARKETING_POLICY} className={cx('link')} target="_blank" rel="noreferrer">
            자세히 보기
          </a>
        </div>

        <p className={cx('desc')}>{'추후 마이페이지 > 알림관리에서 변경할 수 있습니다.'}</p>

        <button className={cx('btnConfirm')} onClick={handleAgree} disabled={!emailYn || !smsYn}>
          확인
        </button>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <Icon name="closeLight" width={24} height={24} />
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default MarketingPolicyAgreeModal;
